const getCollectionDocument = async (collectionRef, documentRef) => {
  const fetchedCollection = await collectionRef.doc(documentRef).get();
  if (fetchedCollection.exists) {
    return fetchedCollection.data();
  }
};
export default getCollectionDocument;
